"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var react_redux_1 = require("react-redux");
var EnhancedTableBody_1 = __importDefault(require("./EnhancedTableBody"));
var MemoTablePagination_1 = __importDefault(require("./MemoTablePagination"));
var actions_1 = __importDefault(require("../../../actions"));
var useStyles = core_1.makeStyles(function (theme) {
    return core_1.createStyles({
        urlTable: {
            paddingTop: theme.spacing(2),
            paddingBottom: theme.spacing(4),
            minHeight: '500px',
        },
    });
});
var UrlTable = function () {
    var classes = useStyles();
    var urlCount = react_redux_1.useSelector(function (state) { return state.user.urlCount; });
    var tableConfig = react_redux_1.useSelector(function (state) { return state.user.tableConfig; });
    var dispatch = react_redux_1.useDispatch();
    var updateUrlTableConfig = function (config) {
        dispatch(actions_1.default.setUrlTableConfig(config));
        dispatch(actions_1.default.getUrlsForUser());
    };
    return (react_1.default.createElement("div", { className: classes.urlTable },
        react_1.default.createElement(EnhancedTableBody_1.default, null),
        react_1.default.createElement(MemoTablePagination_1.default, { urlCount: urlCount, tableConfig: tableConfig, updateUrlTableConfig: updateUrlTableConfig })));
};
exports.default = UrlTable;
